import { render, staticRenderFns } from "./ProgressMenu.vue?vue&type=template&id=23f00a93&scoped=true&"
import script from "./ProgressMenu.vue?vue&type=script&lang=js&"
export * from "./ProgressMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f00a93",
  null
  
)

export default component.exports